import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDRomqTWSDtpsurKhng5o3f8jSRauqR3Cc",
  authDomain: "rightly-9fc2d.firebaseapp.com",
  projectId: "rightly-9fc2d",
  storageBucket: "rightly-9fc2d.firebasestorage.app",
  messagingSenderId: "24777312865",
  appId: "1:24777312865:web:f0837e4c55faa595c6f820",
  measurementId: "G-Y1SKH5H4M0"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

export default app;
